/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// Collection Tabs Web Component
// Handles tab switching and slider navigation
var CollectionTabsComponent = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CollectionTabsComponent, _HTMLElement);
  var _super = _createSuper(CollectionTabsComponent);
  function CollectionTabsComponent() {
    var _this;
    _classCallCheck(this, CollectionTabsComponent);
    _this = _super.call(this);
    _this.tabButtons = _this.querySelectorAll('.collection-tab__button');
    _this.panels = _this.querySelectorAll('.collection-tabs__panel');
    _this.prevButton = _this.querySelector('.collection-tab__arrow--prev');
    _this.nextButton = _this.querySelector('.collection-tab__arrow--next');
    _this.activeTabIndex = 0;
    _this.activeSlider = null;
    _this.init();
    return _this;
  }
  _createClass(CollectionTabsComponent, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      // Set up tab button click handlers
      this.tabButtons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          return _this2.switchTab(index);
        });
      });

      // Set up arrow navigation
      if (this.prevButton) {
        this.prevButton.addEventListener('click', function () {
          return _this2.navigateSlider('prev');
        });
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', function () {
          return _this2.navigateSlider('next');
        });
      }

      // Initialize first slider as active
      this.updateActiveSlider();
    }
  }, {
    key: "switchTab",
    value: function switchTab(index) {
      if (index === this.activeTabIndex) return;

      // Update tab buttons
      this.tabButtons.forEach(function (button, i) {
        button.classList.toggle('active', i === index);
        button.setAttribute('aria-selected', i === index);
      });

      // Update panels
      this.panels.forEach(function (panel, i) {
        var isActive = i === index;
        panel.classList.toggle('active', isActive);
        panel.hidden = !isActive;
      });

      // Update active index and slider reference
      this.activeTabIndex = index;
      this.updateActiveSlider();
    }
  }, {
    key: "updateActiveSlider",
    value: function updateActiveSlider() {
      // Find the slider in the active panel
      var activePanel = this.panels[this.activeTabIndex];
      if (activePanel) {
        this.activeSlider = activePanel.querySelector('.slider');
        this.updateArrowStates();
      }
    }
  }, {
    key: "navigateSlider",
    value: function navigateSlider(direction) {
      var _this3 = this;
      if (!this.activeSlider) return;
      var scrollAmount = this.getScrollAmount();
      var currentScroll = this.activeSlider.scrollLeft;
      if (direction === 'prev') {
        this.activeSlider.scrollTo({
          left: currentScroll - scrollAmount,
          behavior: 'smooth'
        });
      } else {
        this.activeSlider.scrollTo({
          left: currentScroll + scrollAmount,
          behavior: 'smooth'
        });
      }

      // Update arrow states after scroll animation
      setTimeout(function () {
        return _this3.updateArrowStates();
      }, 300);
    }
  }, {
    key: "getScrollAmount",
    value: function getScrollAmount() {
      if (!this.activeSlider) return 0;

      // Get the width of one slide
      var firstSlide = this.activeSlider.querySelector('.slider__slide');
      if (firstSlide) {
        return firstSlide.offsetWidth;
      }

      // Fallback to viewport width
      return this.activeSlider.offsetWidth * 0.8;
    }
  }, {
    key: "updateArrowStates",
    value: function updateArrowStates() {
      if (!this.activeSlider || !this.prevButton || !this.nextButton) return;
      var _this$activeSlider = this.activeSlider,
        scrollLeft = _this$activeSlider.scrollLeft,
        scrollWidth = _this$activeSlider.scrollWidth,
        clientWidth = _this$activeSlider.clientWidth;
      var isAtStart = scrollLeft <= 0;
      var isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;
      this.prevButton.disabled = isAtStart;
      this.nextButton.disabled = isAtEnd;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this4 = this;
      // Listen for scroll events to update arrow states
      if (this.activeSlider) {
        this.activeSlider.addEventListener('scroll', function () {
          return _this4.updateArrowStates();
        });
      }

      // Handle window resize
      this.resizeObserver = new ResizeObserver(function () {
        return _this4.updateArrowStates();
      });
      this.resizeObserver.observe(this);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }]);
  return CollectionTabsComponent;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element
if (!customElements.get('collection-tabs-component')) {
  customElements.define('collection-tabs-component', CollectionTabsComponent);
}

// Product Slider Web Component
// Handles slider navigation for featured products slider
var ProductSliderComponent = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(ProductSliderComponent, _HTMLElement2);
  var _super2 = _createSuper(ProductSliderComponent);
  function ProductSliderComponent() {
    var _this5;
    _classCallCheck(this, ProductSliderComponent);
    _this5 = _super2.call(this);
    _this5.prevButton = _this5.querySelector('.product-slider__arrow--prev');
    _this5.nextButton = _this5.querySelector('.product-slider__arrow--next');
    _this5.slider = _this5.querySelector('.slider');
    _this5.init();
    return _this5;
  }
  _createClass(ProductSliderComponent, [{
    key: "init",
    value: function init() {
      var _this6 = this;
      // Set up arrow navigation
      if (this.prevButton) {
        this.prevButton.addEventListener('click', function () {
          return _this6.navigateSlider('prev');
        });
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', function () {
          return _this6.navigateSlider('next');
        });
      }

      // Initialize arrow states
      this.updateArrowStates();
    }
  }, {
    key: "navigateSlider",
    value: function navigateSlider(direction) {
      var _this7 = this;
      if (!this.slider) return;
      var scrollAmount = this.getScrollAmount();
      var currentScroll = this.slider.scrollLeft;
      if (direction === 'prev') {
        this.slider.scrollTo({
          left: currentScroll - scrollAmount,
          behavior: 'smooth'
        });
      } else {
        this.slider.scrollTo({
          left: currentScroll + scrollAmount,
          behavior: 'smooth'
        });
      }

      // Update arrow states after scroll animation
      setTimeout(function () {
        return _this7.updateArrowStates();
      }, 300);
    }
  }, {
    key: "getScrollAmount",
    value: function getScrollAmount() {
      if (!this.slider) return 0;

      // Get the width of one slide
      var firstSlide = this.slider.querySelector('.slider__slide');
      if (firstSlide) {
        return firstSlide.offsetWidth;
      }

      // Fallback to viewport width
      return this.slider.offsetWidth * 0.8;
    }
  }, {
    key: "updateArrowStates",
    value: function updateArrowStates() {
      if (!this.slider || !this.prevButton || !this.nextButton) return;
      var _this$slider = this.slider,
        scrollLeft = _this$slider.scrollLeft,
        scrollWidth = _this$slider.scrollWidth,
        clientWidth = _this$slider.clientWidth;
      var isAtStart = scrollLeft <= 0;
      var isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;
      this.prevButton.disabled = isAtStart;
      this.nextButton.disabled = isAtEnd;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this8 = this;
      // Listen for scroll events to update arrow states
      if (this.slider) {
        this.slider.addEventListener('scroll', function () {
          return _this8.updateArrowStates();
        });
      }

      // Handle window resize
      this.resizeObserver = new ResizeObserver(function () {
        return _this8.updateArrowStates();
      });
      this.resizeObserver.observe(this);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }]);
  return ProductSliderComponent;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element
if (!customElements.get('product-slider-component')) {
  customElements.define('product-slider-component', ProductSliderComponent);
}

/***/ }),

/***/ "./src/scss/sr-custom.scss":
/*!*********************************!*\
  !*** ./src/scss/sr-custom.scss ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/sr-custom": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/sr-custom"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/sr-custom"], () => (__webpack_require__("./src/scss/sr-custom.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;